import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { INTENT_SAME_AS_WEB } from '@/lib/react-native/services/react-native.intent'

import { Link } from '@/ui/links/link/Link.client'

export function AddressPhoneNumber({
  phone,
  'data-testid': dataTestid,
  onPhonePress,
}: UiComponentProps & { phone: string; onPhonePress?: () => void }) {
  const { t } = useTranslation(['address'])

  return (
    <span>
      {t('address:tel.prefix')}{' '}
      <Link
        bold
        data-testid={`${dataTestid}/phone`}
        href={`tel: ${phone}`}
        aria-label={t('address:tel.title')}
        onPress={onPhonePress}
        intent={INTENT_SAME_AS_WEB}
      >
        {phone}
      </Link>
    </span>
  )
}
